<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "Main"
}
</script>

<style scoped>

</style>